
// This file is generated. Do not modify it manually.
// Run 'bun nx run legacy-datatap-paths:generate-get-path-to' to regenerate this file.

export const getPathTo = {
  administration: () => `/administration/`,
  connectorEngine: () => `/connector-engine/`,
  connectorEngineConnector: ({ connectorSlug }: { connectorSlug: string }) => `/connector-engine/${connectorSlug}/`,
  connectorEngineConnectorConfig: ({ connectorSlug }: { connectorSlug: string }) => `/connector-engine/${connectorSlug}/config/`,
  connectorEngineConnectorWorkflow: ({ connectorSlug, workflow }: { connectorSlug: string, workflow: string }) => `/connector-engine/${connectorSlug}/workflow/${workflow}/`,
  connectorEngineHelp: () => `/connector-engine/help/`,
  datastreamDetails: ({ datastreamId, id }: { datastreamId: number, id: string }) => `/datastreams/${datastreamId}/details/${id}/`,
  datastreamOverview: ({ datastreamId }: { datastreamId: number }) => `/datastreams/${datastreamId}/`,
  datastreamSettings: ({ datastreamId }: { datastreamId: number }) => `/datastreams/${datastreamId}/settings/`,
  datastreamSetupDestinations: ({ datastreamId }: { datastreamId: number }) => `/datastream_setup/${datastreamId}/destinations/`,
  datastreamWorkflow: ({ datastreamId }: { datastreamId: number }) => `/datastreams/${datastreamId}/workflow/`,
  downloadJobArtifact: ({ artifactId }: { artifactId: number }) => `/api/web-app/artifact/${artifactId}/download/`,
  enrichmentsImport: () => `/enrichments/enrichment/import/`,
  exploreUpsell: () => `/feature/explore/`,
  home: () => `/home/`,
  login: ({ next }: { next?: string } = {}) => `/login/${next ? `?next=${next}` : ''}`,
  mappingTables: () => `/mapping/mappingtable/`,
  mediaScreenshots: () => `/imgsrv/mediascreenshot/`,
  oauthInvite: () => `/oauth2/invite/`,
  oauthReauthorize: ({ id }: { id: string }) => `/oauth2/reauthorize/${id}/`,
  oauthReauthorizeEmailForm: ({ id }: { id: string }) => `/oauth2/reauthorize/${id}/email-form/`,
  onboardingLanding: ({ agent_id }: { agent_id: unknown }) => `/agents/${agent_id}/`,
  performanceManager: () => `/performance-manager/`,
  presentUpsell: () => `/feature/present/`,
  profile: () => `/accounts/profile/`,
  redirected: () => `/redirected/`,
  targetColumns: () => `/target/targetcolumns/`,
  transferList: () => `/target/list/`,
  usageManagerUnsubscribe: () => `/usage-manager/unsubscribe/`,
  users: () => `/accounts/user/`,
  usersAdd: () => `/accounts/user/add/`,
  valueTables: () => `/mapping/valuetable/`,
  workspace: ({ stackSlug }: { stackSlug: string }) => `/activity/${stackSlug}/`,
  workspaceDetails: ({ stackSlug }: { stackSlug: string }) => `/activity/${stackSlug}/details/`,
  workspaceJobDetails: ({ stackSlug, jobId }: { stackSlug: string, jobId: number }) => `/activity/${stackSlug}/details/${jobId}/`,
  workspaceMappings: () => `/adverity_workspace/adverityworkspacemappingtable/`,
  workspaceMappingsDetails: ({ mappingTableId }: { mappingTableId: number }) => `/adverity_workspace/adverityworkspacemappingtable/mappings/${mappingTableId}/`
};
